import { Col, Container, InputGroup, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import DashboardLayout from "../../../components/layouts/DashboardLayout";
import PageHeading from "../../../components/pageHeading";
import "./setting.scss";
import { useEffect, useState } from "react";
import useFetch from "../../../hooks/useFetch";
import { toast } from "react-toastify";
import { notifyBugsnagError, showToast } from "../../../common/utils/Functions";
import ReactLoader from "../../../components/reactLoader/ReactLoader";

const Settings = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedTransfer, setIsCheckedTransfer] = useState(false);
  const [isCheckedExternalNotifications, setIsCheckedExternalNotifications] = useState(false);
  const [
    settingApi,
    { response: settingResponse, loading: settingLoading, error: settingError },
  ] = useFetch("admin/change-tipping-settings", {
    method: "POST",
  });

  const [
    disableTransferApi,
    { response: disableTransferResponse, loading: disableTransferLoading, error: disableTransferError },
  ] = useFetch("admin/change-transfer-settings", {
    method: "POST",
  });

  const [
    getsettingApi,
    {
      response: getSettingResponse,
      loading: getSettingLoading,
      error: getSettingError,
    },
  ] = useFetch("admin/get-tipping-settings");


  const [
    externalNotificationsApi,
    { response: externalNotificationsResponse, loading: externalNotificationsLoading, error: externalNotificationsError },
  ] = useFetch("admin/change-external-notifications-settings", {
    method: "POST",
  });

  const handleExternalNotificationsChange = (e: any) => {
    const isEnableExternalNotifications = e.target.checked;
    setIsCheckedExternalNotifications(isEnableExternalNotifications);
    try {
      externalNotificationsApi({
        is_external_notifications_enabled: isEnableExternalNotifications ? 1 : 0,
      });
    } catch (e: any) {
      notifyBugsnagError(externalNotificationsError, {
        api: "externalNotificationsApi",
      });
    }
  };

  useEffect(() => {
    if (externalNotificationsResponse) {
      showToast(externalNotificationsResponse.message, "success");
    }
    if (externalNotificationsError) {
      showToast(externalNotificationsError.message, "error");
    }
  }, [externalNotificationsResponse, externalNotificationsError]);

  /** @function to handle the onChange event of setting */
  const handleSettingChange = (e: any) => {
    const isEnable = e.target.checked;
    setIsChecked(isEnable);
    // setIsCheckedTransfer(isEnable);
    try {
      settingApi({
        is_tipping_enabled: isEnable ? 1 : 0,
      });
    } catch (e: any) {
      notifyBugsnagError(settingError, {
        api: "settingApi",
      });
    }
  };

  useEffect(() => {
    if (settingResponse) {
      showToast(settingResponse.message, "success");
    }
    if (settingError) {
      showToast(settingError.message, "error");
    }
  }, [settingResponse, settingError]);

  /** @function to handle the onChange event of setting */
  const handleDisableChange = (e: any) => {
    const isEnableTransfer = e.target.checked;
    setIsCheckedTransfer(isEnableTransfer);
    try {
      disableTransferApi({
        is_transfer_enabled: isEnableTransfer ? 1 : 0,
      });
    } catch (e: any) {
      notifyBugsnagError(disableTransferError, {
        api: "disableTransferApi",
      });
    }
  };

  useEffect(() => {
    if (disableTransferResponse) {
      showToast(disableTransferResponse.message, "success");
    }
    if (disableTransferError) {
      showToast(disableTransferError.message, "error");
    }
  }, [disableTransferResponse, disableTransferError]);

  useEffect(() => {
    getsettingApi();
  }, []);
  useEffect(() => {
    if (getSettingResponse) {
      setIsChecked(getSettingResponse?.data?.is_tipping_enabled);
      setIsCheckedTransfer(getSettingResponse?.data?.is_transfer_enabled);
      setIsCheckedExternalNotifications(getSettingResponse?.data?.is_external_notifications_enabled);
    }
    if (getSettingError) {
      showToast(getSettingError.message, "error");
    }
  }, [getSettingResponse, getSettingError]);
  return (
    <DashboardLayout>
      {getSettingLoading ? (
        <ReactLoader viewHeight={"calc(100vh - 200px)"} />
      ) : (
        <div className={"dash_page"}>
          <Container>
            <PageHeading
              heading="Settings"
              subHeading="Here you can change your account settings."
            />
            <Row>
              <Col xs={12} md={6} lg={5}>
                <div className={"setting_card"}>
                  <div>
                    <h6>Disable Tipping</h6>
                    <p>
                      Here you can Enable/Disable Tipping for All Organizations.
                    </p>
                  </div>
                  <div className={"toggleButton"}>
                    <InputGroup className="inputGroup">
                      <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        className={"form_check"}
                        disabled={settingLoading}
                        checked={isChecked}
                        onChange={(e) => {
                          handleSettingChange(e);
                        }}
                      />
                      {/* <span
                        style={{
                          left: isChecked ? "10%" : "",
                          right: isChecked ? "" : "10%",
                        }}
                      >
                        {isChecked ? "ON" : "OFF"}
                      </span> */}
                    </InputGroup>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col xs={12} md={6} lg={5}>
                <div className={"setting_card"}>
                  <div>
                    <h6>Disable Transfers</h6>
                    <p>
                      Here you can Enable/Disable Transfers for All Organizations.
                    </p>
                  </div>
                  <div className={"toggleButton"}>
                    <InputGroup className="inputGroup">
                      <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        className={"form_check"}
                        disabled={disableTransferLoading}
                        checked={isCheckedTransfer}
                        onChange={(e) => {
                          handleDisableChange(e);
                        }}
                      />
                      {/* <span
                        style={{
                          left: isChecked ? "10%" : "",
                          right: isChecked ? "" : "10%",
                        }}
                      >
                        {isChecked ? "ON" : "OFF"}
                      </span> */}
                    </InputGroup>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col xs={12} md={6} lg={5}>
                <div className={"setting_card"}>
                  <div>
                    <h6>Disable External Notifications</h6>
                    <p>
                      Here you can Enable/Disable external notifications for All Organizations.
                    </p>
                  </div>
                  <div className={"toggleButton"}>
                    <InputGroup className="inputGroup">
                      <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        className={"form_check"}
                        disabled={externalNotificationsLoading}
                        checked={isCheckedExternalNotifications}
                        onChange={(e) => {
                          handleExternalNotificationsChange(e);
                        }}
                      />
                      {/* <span
                        style={{
                          left: isChecked ? "10%" : "",
                          right: isChecked ? "" : "10%",
                        }}
                      >
                        {isChecked ? "ON" : "OFF"}
                      </span> */}
                    </InputGroup>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </DashboardLayout>
  );
};

export default Settings;
